import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_27_427)" }, [
      _createElementVNode("path", {
        d: "M12.0178 3.72975H9.02171V0.733619C9.02171 0.535707 8.86124 0.375244 8.66333 0.375244H4.62108C4.42317 0.375244 4.26271 0.535707 4.26271 0.733619V3.72975H1.26658C1.06867 3.72975 0.908203 3.89021 0.908203 4.08812V8.1304C0.908203 8.32831 1.06867 8.48877 1.26658 8.48877H4.26271V11.4849C4.26271 11.6828 4.42317 11.8433 4.62108 11.8433H8.66335C8.86127 11.8433 9.02173 11.6828 9.02173 11.4849V8.48875H12.0178C12.2157 8.48875 12.3762 8.32829 12.3762 8.13037V4.08812C12.3762 3.89019 12.2157 3.72975 12.0178 3.72975ZM11.6595 7.772H8.66333C8.46542 7.772 8.30496 7.93246 8.30496 8.13037V11.1265H4.97946V8.13037C4.97946 7.93246 4.819 7.772 4.62108 7.772H1.62495V4.4465H4.62108C4.819 4.4465 4.97946 4.28604 4.97946 4.08812V1.09199H8.30498V4.08812C8.30498 4.28604 8.46544 4.4465 8.66335 4.4465H11.6595V7.772Z",
        fill: "#E11D23"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_27_427" }, [
        _createElementVNode("rect", {
          width: "11.468",
          height: "11.468",
          fill: "white",
          transform: "translate(0.908203 0.375244)"
        })
      ])
    ], -1)
  ])))
}